/* global imagesLoaded */
import $ from 'jquery';
import Cookies from 'js-cookie';
import core from '../core';

class CookieBar {
    static $el = null;

    /**
     * Setup
     */
    static setup() {
        const $el = $('.js-cookie-bar');

        if (! $el.length) {
            return;
        }

        CookieBar.$el = $el;
        CookieBar.CheckCookie();
        CookieBar.bindEvents();
    }

    /**
     * Events
     */
    static bindEvents() {
        CookieBar.$el.on('click', '.js-cookie-bar__accept-btn', CookieBar.onAccept);
    }

    /**
     * Handle button
     *
     * @param {Object} evt
     */
    static onAccept(evt) {
        if (evt) {
            evt.preventDefault();
        }

        $(evt.target)
            .closest(CookieBar.$el)
            .addClass('cookie-bar--accepted');

        Cookies.set('cookie_notice_accepted', 'true', {expires: 365});
    }

    /**
     * Check cookie
     */
    static CheckCookie() {
        if (!Cookies.get('cookie_notice_accepted')) {
            CookieBar.$el.removeClass('cookie-bar--accepted');
        }
    }
}

core.Ready(CookieBar.setup);
